module.exports = {
    'color-1': {
        name: 'Color 1',
        fillAll: true,
        placeholderColor: 'rgb(211,208,201)',
        border: [
          [0, 0],
          [2, 0],
          [2, 2],
          [0, 2],
          [0, 0],
          [4, 0],
          [4, 2],
          [2, 2],
          [2, 0],
          [0, 0],
          [0, 2],
          [2, 2],
          [2, 4],
          [0, 4],
          [0, 2],
          [0, 4],
          [2, 4],
          [2, 2],
          [4, 2],
          [4, 4],
          [0, 4],
    
          [0, 8],
          [2, 8],
          [2, 10],
          [0, 10],
          [0, 8],
          [4, 8],
          [4, 10],
          [2, 10],
          [2, 8],
          [4, 8],
          [4, 12],
          [2, 12],
          [2, 10],
          [4, 10],
          [4, 12],
          [2, 12],
          [0,12],
          [0, 10],
          [2, 10],
          [2, 12],
          [0, 12],
    
          [8, 12],
          [8, 10],
          [10, 10],
          [10, 12],
          [8, 12],
          [8, 8],
          [10, 8],
          [10, 10],
          [8, 10],
          [8, 8],
          [10, 8],
          [12, 8],
          [12, 10],
          [10, 10],
          [10, 8],
          [12, 8],
          [12, 10],
          [12, 12],
          [10, 12],
          [10, 10],
          [12, 10],
          [12, 12],
          [0, 12],
          [0, 0],
    
          [8, 0],
          [8, 2],
          [10, 2],
          [10, 0],
          [8, 0],
          [8, 4],
          [10, 4],
          [10, 2],
          [8, 2],
          [8, 0],
          [12, 0],
          [12, 2],
          [10, 2],
          [10, 0],
          [12, 0],
          [12, 2],
          [10, 2],
          [10, 4 ],
          [12, 4],
          [12, 0],
        ]      
    },
    'color-2': {
        name: 'Color 2',
        fillAll: true,
        placeholderColor: 'rgb(159,160,163)',
        border: [
          [0, 0],
          [0, 4],
          [2, 4],
          [2, 6],
          [0, 6],
          [0, 4],
          [4, 4],
          [4, 6],
          [2, 6],
          [2, 4],
          [0, 4],
          [0, 6],
          [2, 6],
          [2, 8],
          [0, 8],
          [0, 6],
          [4, 6],
          [4, 8],
          [2, 8],
          [2, 6],
          [0, 6],
    
          [0, 12],
          [4, 12],
          [4, 8],
          [6, 8],
          [6, 10],
          [4, 10],
          [4, 8],
          [8, 8],
          [8, 10],
          [6, 10],
          [6, 8],
          [4, 8],
          [4, 12],
          [4, 10],
          [6, 10],
          [6, 12],
          [4, 12],
          [6, 12],
          [6, 10],
          [8, 10],
          [8, 12],
          [6, 12],
          [8, 12],
          [4, 12],
          
          [12, 12],
          [0, 12],
          [0, 0],
    
          [6, 0],
          [6, 2],
          [4, 2],
          [4, 0],
          [6, 0],
          [6, 4],
          [4, 4],
          [4, 2],
          [6, 2],
          [6, 0],
          [8, 0],
          [8, 2],
          [6, 2],
          [6, 0],
          [6, 2],
          [8, 2],
          [8, 4],
          [6, 4],
          [6, 2],
          [6, 0 ],
          [12, 0],
    
          [12, 4], 
          [10, 4],
          [10, 6],
          [12, 6],
          [12, 4],
          [10, 4],
          [10, 8],
          [12, 8],
          [12, 4],
          [8, 4],
          [8, 6],
          [10, 6],
          [10, 4],
          [8, 4],
          [8, 8],
          [10, 8],
          [10, 6],
          [8, 6],
          [8, 4],
          [12, 4],
    
          [12, 0]
    
    
        ]      
    },
    'color-3': {
        name: 'Color 3',
        fillAll: true,
        placeholderColor: 'rgb(106,106,110)',
        border: [
          [0, 0],
          [4, 0],
          [4, 4],
          [6, 4],
          [6, 6],
          [4, 6],
          [4, 4],
    
          [8, 4],
          [8, 6],
          [6, 6],
          [6, 4],
          [4, 4],
          [4, 6],
          [6, 6],
          [4, 6],
          [4, 8],
          [6, 8],
          [6, 6],
          [8, 6],
          [8, 8],
          [4, 8],
          [4, 6],
          [6, 6],
          [6, 8],
          [4, 8],
          [4, 0]
        ]      
    },
};


// WEBPACK FOOTER //
// ./src/universal/filzfelt/blocks/gingham.js